/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('modules/Delivery/DeliveryOptions',[
    'jquery',
    'lodash',
    'global/all',
    'global/Geolocation',
    'modules/InStorePickup/InStorePickup',
    'modules/Product/ProductService',
    'modules/Product/ProductOutOfStockService',
    'modules/Store/StoreLocationService',
    'modules/User/Users',
    'modules/Delivery/DeliveryOptions.Forms',
], function ($, _, Roc, Geolocation, InStorePickup, ProductService, ProductOutOfStockService, StoreLocationService, Users, DeliveryForms) {
    'use strict';

    var forms = DeliveryForms;
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var signInUrl;
    var countries;
    var addressBookUrl;
    var deliveryOptions;
    var isProductDetailsPage;
    var currentOrderItemId;
    var currentShipToAddress;
    var selectedStoreId = null;
    var showHideAddToCartButtonCallback;


    function getUomId() {
        return $('#selectedUom').val() || null;
    }

    function getDeliveryOptions(productId, orderItemId, uomId) {
        var request = {
            'productId': productId
        };

        if (orderItemId) {
            request.orderItemId = orderItemId;
        }

        if (uomId) {
            request.uomId = uomId;
        }

        //if it's a guest user try go include previously selected store id
        if (!Users.isLoggedIn() && selectedStoreId) {
            request.storeId = selectedStoreId;
        }

        // TODO: here 

        return $.ajax({
            url: apiUrl + '/api/productdelivery/',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(request)
        });
    }

    function getDeliveryContainer(src) {
        return $(src).closest('.delivery-option-list');
    }

    function getProductIdFromContainer($deliveryContainer) {
        return $deliveryContainer.attr('data-roc-productId');
    }

    function getOrderItemIdFromContainerAttr($deliveryContainer) {
        return $deliveryContainer.attr('data-roc-order-item-id');
    }

    function getSelectedAddressBookIdFromContainer($deliveryContainer) {
        var $hdn = $deliveryContainer.find('input.hdnDeliveryAddressId');
        if ($hdn.length === 1 && $hdn.val() !== Roc.Enums.general.DEFAULT_GUID) {
            return $hdn.val();
        }
        return null;
    }

    function getDeliveryContainerFromModal(element) {
        var $modalContainer = $(element).closest('div.white-popup');
        var productId = $modalContainer.attr('data-roc-productId');
        var orderItemId = $modalContainer.attr('data-roc-order-item-id');
        var itemQty = parseInt($modalContainer.attr('data-roc-quantity'));
        return {
            productId: productId,
            orderItemId: orderItemId,
            itemQty: itemQty,
            $modal: $modalContainer,
            $container: $('.delivery-option-list[data-roc-productId="' + productId + '"][data-roc-order-item-id="' + orderItemId + '"]')
        };
    }

    function getAddRecipientForm($modal) {
        var tmpForm = $.extend(true, {}, forms.addRecipient);

        _.forEach(tmpForm.Fields, function (field) {
            field.Field = '#' + $modal.attr('id') + " " + field.Field;
            if (field.hasOwnProperty("Validators")) {
                _.forEach(field.Validators, function (validator) {
                    if (validator.hasOwnProperty("ConditionalField")) {
                        validator.ConditionalField = '#' + $modal.attr('id') + " " + validator.ConditionalField;
                    }
                    if (validator.hasOwnProperty("ReferencedField")) {
                        validator.ReferencedField = '#' + $modal.attr('id') + " " + validator.ReferencedField;
                    }
                });
            }
        });

        return tmpForm;
    }

    function validateAddRecipientForm($modal) {
        var form = getAddRecipientForm($modal);
        return Roc.Validation.validateForm(form);
    }

    function updateRecipient($deliveryContainer, recipientData) {
        if (recipientData) {
            $deliveryContainer.find('.hdnAddRecipientFirstName').val(recipientData.firstName);
            $deliveryContainer.find('.hdnAddRecipientLastName').val(recipientData.lastName);
            $deliveryContainer.find('.hdnAddRecipientZip').val(recipientData.zip);
            $deliveryContainer.find('.hdnAddRecipientCity').val(recipientData.city);
            $deliveryContainer.find('.hdnAddRecipientCountry').val(recipientData.country);
            $deliveryContainer.find('.hdnAddRecipientState').val(recipientData.state);
        } else {
            $deliveryContainer.find('input[class^="hdnAddRecipient"]').val('');
        }
    }

    function clearAddRecipientForm($deliveryContainer) {
        var form = getAddRecipientForm($deliveryContainer);

        _.forEach(form.Fields, function (f) {
            $(f.Field).val('');
        });

        Roc.UI.clearFormErrors(form);
        updateRecipient($deliveryContainer);
    }

    function updateDeliveryType($deliveryContainer, deliveryType, notify) {
        var orderItemId = getOrderItemIdFromContainerAttr($deliveryContainer);
        $deliveryContainer.find('input[name="delivery-type-' + orderItemId + '"]').attr('checked', false);
        $deliveryContainer.find('input[name="delivery-type-' + orderItemId + '"][value="' + deliveryType + '"]').prop('checked', true);
        $deliveryContainer.find('.hdnDeliveryType').val(deliveryType);
        if (notify) {
            var productId = getProductIdFromContainer($deliveryContainer);
            Roc.EventManager.notify(Roc.Events.delivery.DELIVERY_OPTION_CHANGED, {
                'productId': productId,
                'orderItemId': orderItemId,
                'deliveryType': deliveryType
            });
        }
    }

    function displayRecipientSummary($deliveryContainer, summary) {
        $deliveryContainer.find('.delivery-option span.recipient-summary').text(summary);
    }

    function deliveryOptionEvt() {
        Roc.UI.siteBody
            .off('click', 'input[type="radio"][name^="delivery-type"]')
            .on('click', 'input[type="radio"][name^="delivery-type"]', function () {
                var deliveryType = $(this).val();
                var $deliveryContainer = getDeliveryContainer(this);
                updateDeliveryType($deliveryContainer, deliveryType, true);
            });
    }

    function deliveryModalOpenedEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="openDeliveryModal"]')
            .on('click', '[data-roc-action="openDeliveryModal"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                var itemId = getOrderItemIdFromContainerAttr($deliveryContainer);
                var selectedAddressId = getSelectedAddressBookIdFromContainer($deliveryContainer);
                if (selectedAddressId) {
                    clearAddRecipientForm($deliveryContainer);
                    $deliveryContainer.find('input[name="delivery-shipping"][value="' + selectedAddressId + '"]').prop('checked', true);
                } else {
                    $deliveryContainer.find('input.delivery-first-name').val($deliveryContainer.find('.hdnAddRecipientFirstName').val());
                    $deliveryContainer.find('input.delivery-last-name').val($deliveryContainer.find('.hdnAddRecipientLastName').val());
                    $deliveryContainer.find('input.delivery-zip').val($deliveryContainer.find('.hdnAddRecipientZip').val());
                    $deliveryContainer.find('input.delivery-city').val($deliveryContainer.find('.hdnAddRecipientCity').val());
                    $deliveryContainer.find('select.delivery-country').val($deliveryContainer.find('.hdnAddRecipientCountry').val() || window.RocConfig.defaultCountryCode).trigger(Roc.Events.general.CHANGE);
                    $deliveryContainer.find('input.delivery-state').val($deliveryContainer.find('.hdnAddRecipientState').val());
                    $deliveryContainer.find('input[name="delivery-shipping"]').prop('checked', false);
                }
                Roc.UI.Modal.open('#delivery-ship-' + itemId);
                bindCountryChangeEvt();
                bindZipCodeLookUpEvt();
            });
    }

    function bindCountryChangeEvt() {
        var selector = '#delivery-country';
        var eventNameWithNamespace = 'change.deliveryOptions-bindCountryChangeEvt';
        $(document)
            .off(eventNameWithNamespace, selector)
            .on(eventNameWithNamespace, selector, function () {
                bindZipCodeLookUpEvt();
            });
    }

    function bindZipCodeLookUpEvt() {
        if (window.RocConfig.google.enableAddressAutocomplete === true) {
            // bind zip code lookup plugin
            var countryCode = $('#delivery-country').val() || window.RocConfig.defaultCountryCode;
            Roc.UI.ziplookup('input.delivery-zip', {
                country: countryCode,
                fieldsMapping: {
                    "CITY": 'input.delivery-city',
                    "STATE_OR_REGION": 'input.delivery-state'
                }
            });
        }
    }

    function deliveryFormFocusedEvt() {
        Roc.UI.siteBody
            .off('focus', '.recipient-form input[type="text"]')
            .on('focus', '.recipient-form input[type="text"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                $deliveryContainer.find('input[name="delivery-shipping"]').attr("checked", false);
            });
    }

    function signInEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="signInToSeeAddresses"]')
            .on('click', '[data-roc-action="signInToSeeAddresses"]', function () {
                window.location.href = signInUrl;
                Roc.Core.lockButton('[data-roc-action="signInToSeeAddresses"]');
            });
    }

    function addressBookSelectedEvt() {
        Roc.UI.siteBody
            .off('click', 'input[name="delivery-shipping"]')
            .on('click', 'input[name="delivery-shipping"]', function () {
                var addressBookId = $(this).val();
                var result = getDeliveryContainerFromModal(this);
                var alreadySelectedAddress = getSelectedAddressBookIdFromContainer(result.$container);
                if (addressBookId !== alreadySelectedAddress) {
                    updateDeliveryType(result.$container, 'Shipping', false);
                    clearAddRecipientForm(result.$container);
                    var summary = $(this).attr('data-recipient-summary');
                    displayRecipientSummary(result.$container, summary);
                    result.$container.find('.hdnDeliveryAddressId').val(addressBookId);
                    result.$container.find('.hdnAddRecipientFirstName').val('');
                    result.$container.find('.hdnAddRecipientLastName').val('');
                    result.$container.find('.hdnAddRecipientZip').val('');
                    result.$container.find('.hdnAddRecipientCity').val('');
                    result.$container.find('.hdnAddRecipientCountry').val('');
                    result.$container.find('.hdnAddRecipientState').val('');
                    Roc.EventManager.notify(Roc.Events.delivery.ADDRESS_BOOK_SELECTED, {
                        'productId': result.productId,
                        'orderItemId': result.orderItemId,
                        'addressBookId': addressBookId
                    });
                    Roc.UI.Modal.close();
                }
            });
    }

    function submitDeliveryFormEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="submitDeliveryForm"]')
            .on('click', '[data-roc-action="submitDeliveryForm"]', function () {
                var result = getDeliveryContainerFromModal(this);
                if (validateAddRecipientForm(result.$modal)) {
                    var recipientData = Roc.Forms.getFormValues(forms.addRecipient, result.$modal);
                    updateDeliveryType(result.$container, 'Shipping', false);
                    updateRecipient(result.$container, recipientData);

                    displayRecipientSummary(result.$container, Roc.UI.formatRecipientLabel(recipientData));
                    result.$container.find('.hdnDeliveryAddressId').val('');

                    Roc.EventManager.notify(Roc.Events.delivery.RECIPIENT_DATA_PROVIDED, {
                        'productId': result.productId,
                        'orderItemId': result.orderItemId,
                        'address': recipientData
                    });

                    Roc.UI.Modal.close();
                }
            });
    }

    function cancelDeliveryForm() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="cancelDeliveryForm"]')
            .on('click', '[data-roc-action="cancelDeliveryForm"]', function () {
                Roc.UI.Modal.close();
            });
    }

    function findStoreEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="findAnotherStore"]')
            .on('click', '[data-roc-action="findAnotherStore"]', function () {
                var $deliveryContainer = getDeliveryContainer(this);
                var productId = getProductIdFromContainer($deliveryContainer);
                ProductService.getById(productId).then(function (product) {
                    InStorePickup.findPickupStore(product)
                        .then(function (selectedStore) {
                            selectedStoreId = selectedStore.location.id;
                            deliveryOptions.selectedDeliveryType = 'Pickup';
                            deliveryOptions.inventoryAvailability.pickupDetails = selectedStore;
                            render(deliveryOptions);
                        });
                }, function () {
                    Roc.UI.displayErrorPopup('There was an error while trying to get product details.');
                });
            });
    }

    function prepareViewModel(data) {
        if (data) {
            // extend provided view model with necessary data for template rendering
            $.extend(data, {
                signInUrl: signInUrl,
                countries: countries,
                addressBookUrl: addressBookUrl,
                isProductDetailsPage: isProductDetailsPage,
                defaultCountryCode: window.RocConfig.defaultCountryCode,
                enableInternationalShipping: window.RocConfig.shipping.enableInternationalShipping
            });

            // if user already selected address book or provided address
            // then overwrite "Ship To" data from the api response
            var $deliveryOptions = $('#delivery-options');
            var $addressIdField = $deliveryOptions.find('.hdnDeliveryAddressId');
            if ($addressIdField.length === 1) {
                var addressBookId = $addressIdField.val();
                if (addressBookId !== '') {
                    var selectedAddressBook = _.find(data.addresses, {
                        'id': addressBookId
                    });
                    if (selectedAddressBook) {
                        currentShipToAddress = selectedAddressBook;
                    }
                } else {
                    currentShipToAddress = {
                        'firstName': $deliveryOptions.find('.hdnAddRecipientFirstName').val(),
                        'lastName': $deliveryOptions.find('.hdnAddRecipientLastName').val(),
                        'zip': $deliveryOptions.find('.hdnAddRecipientZip').val(),
                        'city': $deliveryOptions.find('.hdnAddRecipientCity').val(),
                        'country': $deliveryOptions.find('.hdnAddRecipientCountry').val(),
                        'state': $deliveryOptions.find('.hdnAddrecipientState').val()
                    };
                }
            }

            // get email address that could have been provided for out of stock email notification
            // don't force user to provide it again when making selections
            data.outOfStockNotificationEmail = ProductOutOfStockService.getCurrentEmailAddress();

            if (currentShipToAddress) {
                data.shipToAddress = currentShipToAddress;
            }
            return data;
        }
        return null;
    }

    function isAnyDeliveryOptionAvailable() {
        if (deliveryOptions) {
            return deliveryOptions.multiShipToEnabled || deliveryOptions.inStorePickupEnabled;
        }
        return false;
    }

    function verifyAddToCartButtonVisibility() {
        if (typeof showHideAddToCartButtonCallback === 'function') {
            if (isAnyDeliveryOptionAvailable()) { // if there is at least one delivery option available then show/hide add to cart button
                if (deliveryOptions.selectedDeliveryType === 'Virtual') {
                    showHideAddToCartButtonCallback(true);
                    return;
                }
                var shippingAvailable = false;
                var pickupAvailable = false;
                var inventory = deliveryOptions.inventoryAvailability;
                if (inventory) {
                    var unavailableStatuses = ['Unavailable', 'OutOfStock'];
                    shippingAvailable = unavailableStatuses.indexOf(inventory.shippingSummary.status) === -1;
                    pickupAvailable = deliveryOptions.inStorePickupEnabled && inventory.pickupDetails !== null && unavailableStatuses.indexOf(inventory.pickupDetails.inventorySummary.status) === -1;
                }
                showHideAddToCartButtonCallback(shippingAvailable || pickupAvailable);
            }
        }
    }

    function render(data) {
        deliveryOptions = prepareViewModel(data);
        verifyAddToCartButtonVisibility();
        Roc.UI.renderFormTemplate('deliveryOptions-Tmp', deliveryOptions, $('#delivery-options'));
    }

    function getDeliveryOptionsFromContainer($deliveryContainer) {
        var deliveryType = $deliveryContainer.find('input.hdnDeliveryType').val();

        var deliveryOptions = {
            'addressBookId': null,
            'pickupLocationId': null,
            'address': null,
            'deliveryType': deliveryType
        };

        switch (deliveryType) {
            case 'Shipping':
                var selectedAddress = getSelectedAddressBookIdFromContainer($deliveryContainer);
                if (selectedAddress) {
                    deliveryOptions.addressBookId = selectedAddress;
                } else {
                    var country = $deliveryContainer.find('.hdnAddRecipientCountry').val();
                    if (country) {
                        deliveryOptions.address = {
                            'firstName': $deliveryContainer.find('.hdnAddRecipientFirstName').val(),
                            'lastName': $deliveryContainer.find('.hdnAddRecipientLastName').val(),
                            'zip': $deliveryContainer.find('.hdnAddRecipientZip').val(),
                            'city': $deliveryContainer.find('.hdnAddRecipientCity').val(),
                            'country': $deliveryContainer.find('.hdnAddRecipientCountry').val(),
                            'state': $deliveryContainer.find('.hdnAddRecipientState').val()
                        }
                    }
                }
                break;
            case 'Pickup':
                deliveryOptions.pickupLocationId = $deliveryContainer.find('.hdnPickupId').val();
                break;
        }
        return deliveryOptions;
    }

    function getProductDeliveryOptions(productId, orderItemId) {
        var $deliveryContainer;

        if (orderItemId) {
            $deliveryContainer = $('.delivery-option-list[data-roc-productid="' + productId + '"][data-roc-order-item-id="' + orderItemId + '"]');
        } else {
            $deliveryContainer = $('.delivery-option-list[data-roc-productid="' + productId + '"]');
        }

        if ($deliveryContainer.length === 0) {
            return null;
        }

        return getDeliveryOptionsFromContainer($deliveryContainer);
    }

    function reloadDeliveryOptions(productViewModel) {
        if (productViewModel) {
            getDeliveryOptions(productViewModel.id, currentOrderItemId, getUomId(), location)
                .then(function (options) {
                    render(options);
                }, function () {
                    render(null);
                });
        } else {
            render(null);
        }
    }

    function bindEvents() {
        deliveryOptionEvt();
        deliveryModalOpenedEvt();
        signInEvt();
        deliveryFormFocusedEvt();
        addressBookSelectedEvt();
        submitDeliveryFormEvt();
        cancelDeliveryForm();
    }

    function bindProductDetailsEvents() {
        bindEvents();
        findStoreEvt();
    }

    function bindCartPageEvents() {
        bindEvents();
    }

    function baseInit(options) {
        signInUrl = options.signInUrl;
        addressBookUrl = options.addressBookUrl;
        countries = options.countries;
    }

    function initProductDetailsPage(options) {
        isProductDetailsPage = true;
        baseInit(options);
        bindProductDetailsEvents();
        render(options.deliveryOptions);
        currentOrderItemId = options.deliveryOptions.orderItemId;
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadDeliveryOptions);
    }

    function initCartPage(options) {
        baseInit(options);
        bindCartPageEvents();
    };

    function setAddToCartButtonVisibilityCallback(callback) {
        showHideAddToCartButtonCallback = callback;
    }

    var DeliveryOptions = {
        initCartPage: initCartPage,
        initProductDetailsPage: initProductDetailsPage,
        getProductDeliveryOptions: getProductDeliveryOptions,
        isAnyDeliveryOptionAvailable: isAnyDeliveryOptionAvailable,
        setAddToCartButtonVisibilityCallback: setAddToCartButtonVisibilityCallback
    };

    Roc.Logger.debug('DeliveryOptions.js Loaded:', DeliveryOptions);

    return DeliveryOptions;

});
